// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1yIkv","component":"Input_component__203K1","standalone":"Input_standalone__1Q8a6","hasLabel":"Input_hasLabel__3s-sW","label":"Input_label__Q9Uu-"};